import styled, { FlattenSimpleInterpolation, css } from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { HeaderMenuProps } from 'typings/header'
import routePaths from 'const/routePaths'
import { colors } from 'const/colors'
import HeaderNavLink from 'ui/atoms/HeaderNavLink'
import { LinkItemProps } from 'ui/atoms/HeaderNavLink/typing'

const getMenuContainerCSS = (
  padding: string,
  styleType: string,
  backGroundColor: string,
  bdrWidth: string
): FlattenSimpleInterpolation => css`
  margin: 0;
  padding: ${padding || '0'};
  align-items: center;
  list-style-type: ${styleType || 'none'};
  display: flex;
  background-color: ${backGroundColor || 'inherit'};
  border-width: ${bdrWidth || '0'};
  border-style: solid;
`

const HeaderMenuContainer = styled.nav<{ isLoggedIn?: boolean }>`
  display: ${({ isLoggedIn }): string => (isLoggedIn ? 'block' : 'none')};
`

const MenuContainer = styled.ul`
  ${({ padding, styleType, backGroundColor, bdrWidth }: HeaderMenuProps) =>
    getMenuContainerCSS(padding, styleType, backGroundColor, bdrWidth)}
`

const RightNavBar = styled.div`
  display: flex;
`

/** Renders the top menu bar for desktops and wide screens */
export const LargeTopBarMenu = ({
  isAuthenticated
}: {
  isAuthenticated: boolean
}) => {
  const headerItems: Array<LinkItemProps> = [
    {
      linkName: 'User Guide',
      path: routePaths.userGuide
    },
    {
      linkName: 'Log Out',
      path: routePaths.logout
    }
  ]

  return (
    <RightNavBar>
      <HeaderMenuContainer isLoggedIn={isAuthenticated}>
        <MenuContainer>
          {headerItems.map(linkItem => {
            const { path } = linkItem
            return <HeaderNavLink linkItem={linkItem} key={path} />
          })}
        </MenuContainer>
      </HeaderMenuContainer>
    </RightNavBar>
  )
}

const MobileMenuContainer = styled.div`
  display: flex;
  color: ${colors.white};
`

const MenuBar = styled.button`
  color: ${({ theme }): string => theme.headerMenu.color};
  margin-right: 15px;
  background: none;
  padding: 0;
  border: none;
`

const MenuBarIcon = styled(FontAwesomeIcon)`
  font-size: 16px;
  color: ${({ theme }): string => theme.headerMenu.color};
  cursor: pointer;
`

/**
 * Renders the top menu bar for mobile and narrow screens with a hamburger icon
 * to toggle the menu items into view.
 */
export const MobileTopBarMenu = ({
  isOpen,
  onToggleOpen,
  hamburgerButtonRef
}: {
  isOpen: boolean
  /** Called whenever user clicks the icon to toggle open state */
  onToggleOpen: () => void
  hamburgerButtonRef: React.Ref<HTMLButtonElement>
}) => {
  return (
    <MobileMenuContainer>
      <MenuBar
        onClick={onToggleOpen}
        aria-label="Open Menu"
        aria-expanded={isOpen}
        data-test="menu-bar"
        ref={hamburgerButtonRef}
      >
        <MenuBarIcon icon={['far', 'bars']} />
      </MenuBar>
    </MobileMenuContainer>
  )
}
